<template>
  <div id="theReport" class="report-container">
    <div class="header-bar">
      <h2>Pending invoices Breakdown Report</h2>
      <button
        @click="printReport('theReport', 'pending_invoices' + startDate)"
        class="print-button exclude-print"
      >
        🖨 Print
      </button>
    </div>

    <div class="breakdown">
      <table>
        <thead>
          <tr>
            <th>Invoice Number</th>
            <th>Patient Identity</th>
            <th>Insurance Company (where applicable)</th>
            <th>Visit ID</th>
            <th>Invoice_date</th>
            <th>Invoice Amount</th>
            <th class="exclude-print">.</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(type, index) in breakdown_data" :key="index">
            <td>
              {{ type.id }}
            </td>
            <td>
              {{ type.name }}
            </td>
            <td>
              {{
                type.insurance_company == null ? "-" : type.insurance_company
              }}
              {{
                type.insurance_scheme == null
                  ? "-"
                  : "(" + type.insurance_scheme + ")"
              }}
            </td>
            <td>
              {{ type.visit_id }}
            </td>
            <td>
              {{ converted_utc(type.created_at) }}
            </td>
            <td>
              {{ type.value }}
            </td>
            <td class="exclude-print">
              <!-- <span style="float: left">{{ type.value.toLocaleString() }}</span> -->
              <span style="float: right">
                <a
                  class="btn btn-sm"
                  :href="`/invoices/invoiceDetail/${type.id}`"
                  >detail</a
                >
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="totalPending !== null" class="total-revenue">
      <p style="font-size: 1.25em">
        Total Invoiced for <span style="color: brown"><u>Unpaid</u></span> and
        <span style="color: brown"><u>Partially-paid</u></span> Invoices: Ksh.
        <b>{{ totalPending.toLocaleString() }}</b>
      </p>
      <p style="font-size: 1.25em">
        Total <span style="color: brown"><u>Paid</u></span> for Partially-paid
        Invoices: Ksh.
        <b>{{ paid.toLocaleString() }}</b>
      </p>
      <h4>
        Total Pending Invoices Amount: Ksh.
        <b>{{ outstanding_debt.toLocaleString() }}</b>
      </h4>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import PrintDiv from "../../prints/div_to_pdf";
import formatDateTime from "../../timezone/utc_local_time";

export default {
  data() {
    return {
      totalPending: null,
      breakdown_data: [],
      paid: "",
      outstanding_debt: "",
    };
  },
  methods: {
    converted_utc(param) {
      return formatDateTime(param);
    },
    printReport(div, name) {
      return PrintDiv(div, name);
    },
    async fetchPendingInvoices() {
      var req_body = {};

      const url = `pending_invoice_breakdown/` + this.$route.params.invoiceType;
      const res = await generalApiRequest(url, "GET", req_body, 1);
      // console.log("reading this================");

      // console.log(res);

      if (res.status === "success") {
        this.totalPending = res.data.totalPending;
        this.breakdown_data = res.data.breakdown_data;
        this.paid = res.data.total_paid;
        this.outstanding_debt = res.data.outstanding_debt;
      } else {
        alert("Failed to fetch report.");
      }
    },
  },
  mounted() {
    console.log("reading this================");

    this.fetchPendingInvoices(); // auto-fetch for today's data on mount
  },
};
</script>

<style scoped>
/* same CSS as your original — no changes needed */
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.print-button {
  background-color: #4caf50;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.9rem;
  transition: background-color 0.2s ease-in-out;
}

.print-button:hover {
  background-color: #43a047;
}
.report-container {
  max-width: 900px;
  margin: 40px auto;
  padding: 20px;
  border: 1px solid #e2e2e2;
  border-radius: 12px;
  background: #fafafa;
}

.date-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.date-filters label {
  font-weight: 500;
}

.date-filters input {
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.date-filters button {
  padding: 8px 16px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.date-filters button:hover {
  background: #218838;
}

.total-revenue {
  margin-bottom: 30px;
  background: #ffe6e6;
  padding: 15px;
  border-radius: 8px;
}

.breakdown {
  margin-bottom: 30px;
}

.breakdown table {
  width: 100%;
  border-collapse: collapse;
}

.breakdown th,
.breakdown td {
  padding: 10px 12px;
  border: 1px solid #ddd;
  text-align: left;
}

.breakdown th {
  background: #f1f1f1;
}
</style>
